var map = {
	"./Canais.svg": 724,
	"./Facebook_Messenger_4_Logo.svg": 548,
	"./IA.svg": 723,
	"./Icon_chat_ativo.svg": 536,
	"./TelegramQnt.svg": 1244,
	"./accessibility.svg": 790,
	"./add_botao.svg": 446,
	"./adicionar_blue.svg": 447,
	"./análise.svg": 725,
	"./aspas.svg": 448,
	"./atendimentobot.svg": 791,
	"./atendimentohumano.svg": 792,
	"./audio_off.svg": 793,
	"./audio_on.svg": 794,
	"./back.svg": 449,
	"./bloco.svg": 1245,
	"./bloco_campo_rd.svg": 1246,
	"./bloco_criar_lead.svg": 1247,
	"./bot.svg": 795,
	"./bot_users.svg": 796,
	"./botao_download.svg": 797,
	"./busca-preto.svg": 450,
	"./busca.svg": 798,
	"./callcenter.svg": 799,
	"./chat.svg": 298,
	"./check.svg": 800,
	"./clientes.svg": 451,
	"./close.svg": 801,
	"./company.svg": 686,
	"./company_no_logo.svg": 1248,
	"./configs.svg": 1249,
	"./configurações.svg": 721,
	"./criador.svg": 722,
	"./data.svg": 287,
	"./drop_down.svg": 802,
	"./drop_down_2.svg": 803,
	"./duvidas_frequentes.svg": 804,
	"./edit-form.svg": 805,
	"./emailQnt.svg": 1250,
	"./expandir.svg": 445,
	"./facebook-messenger-logo.svg": 806,
	"./fast-forward.svg": 807,
	"./gatilho.svg": 808,
	"./gatilho_ativo.svg": 809,
	"./hash.svg": 810,
	"./humano.svg": 811,
	"./ic_arrow_dropdown_profile.svg": 680,
	"./ic_attachment.svg": 549,
	"./ic_audio.svg": 550,
	"./ic_builder_start_line.svg": 812,
	"./ic_checkbox_check.svg": 1251,
	"./ic_close.svg": 813,
	"./ic_coleta.svg": 814,
	"./ic_coleta_orange.svg": 815,
	"./ic_delete.svg": 1252,
	"./ic_dropdown_profile_attendance.svg": 1253,
	"./ic_dropdown_profile_logout.svg": 684,
	"./ic_dropdown_profile_settings.svg": 1254,
	"./ic_duplicate.svg": 1255,
	"./ic_play.svg": 1256,
	"./ic_plus_white.svg": 349,
	"./ic_random.svg": 816,
	"./ic_random_act.svg": 817,
	"./ic_send_message.svg": 551,
	"./ic_variable.svg": 784,
	"./ic_variaveis.svg": 552,
	"./ico_boteria-beta.svg": 1257,
	"./ico_boteria.svg": 718,
	"./icon-close.svg": 818,
	"./icon-message.svg": 1258,
	"./icon-messenger.svg": 819,
	"./icon-right.svg": 820,
	"./icon-telegram.svg": 821,
	"./icon-webchat.svg": 822,
	"./icon-wpp.svg": 823,
	"./icon_add-form.svg": 824,
	"./icon_add.svg": 533,
	"./icon_add_blue.svg": 297,
	"./icon_add_orange.svg": 537,
	"./icon_adicionar_ao_carrinho.svg": 825,
	"./icon_alert.svg": 826,
	"./icon_atendimento.svg": 1259,
	"./icon_attach_file.svg": 452,
	"./icon_atualizar_carrinho.svg": 827,
	"./icon_bot_transfer.svg": 828,
	"./icon_bot_transfer_orange.svg": 763,
	"./icon_box_arrow_right.svg": 783,
	"./icon_buscar_produto_carrinho.svg": 829,
	"./icon_buscar_produto_catalogo.svg": 830,
	"./icon_channel_settings.svg": 831,
	"./icon_channels_bar.svg": 832,
	"./icon_channels_whatsapp.svg": 833,
	"./icon_chat.svg": 834,
	"./icon_chat_bloco.svg": 752,
	"./icon_check.svg": 835,
	"./icon_checkout.svg": 836,
	"./icon_condicional.svg": 837,
	"./icon_condicional_hover.svg": 1260,
	"./icon_copiar.svg": 437,
	"./icon_copy_orange.svg": 685,
	"./icon_create_custom_report.svg": 838,
	"./icon_create_request.svg": 453,
	"./icon_data.svg": 839,
	"./icon_delete-form.svg": 840,
	"./icon_delete.svg": 553,
	"./icon_delete_create.svg": 1261,
	"./icon_delete_custom.svg": 395,
	"./icon_delete_red.svg": 268,
	"./icon_delete_white.svg": 841,
	"./icon_direcionador.svg": 842,
	"./icon_direcionador_clicked.svg": 843,
	"./icon_direcionador_orange.svg": 762,
	"./icon_direcionador_over.svg": 844,
	"./icon_doc.svg": 681,
	"./icon_drop_down.svg": 1262,
	"./icon_edit.svg": 845,
	"./icon_email.svg": 846,
	"./icon_entregue.svg": 847,
	"./icon_enviado.svg": 848,
	"./icon_erro.svg": 849,
	"./icon_fab_bar_closed.svg": 850,
	"./icon_fab_bar_open.svg": 851,
	"./icon_falta.svg": 852,
	"./icon_fechar_x.svg": 853,
	"./icon_formulario.svg": 1263,
	"./icon_girar.svg": 554,
	"./icon_group.svg": 854,
	"./icon_group_builder.svg": 855,
	"./icon_group_builder_clicked.svg": 856,
	"./icon_group_builder_over.svg": 857,
	"./icon_group_hover.svg": 858,
	"./icon_group_orange.svg": 761,
	"./icon_insert_comment.svg": 396,
	"./icon_json.svg": 555,
	"./icon_lido.svg": 859,
	"./icon_link_out.svg": 682,
	"./icon_list_comment.svg": 556,
	"./icon_list_comments.svg": 1264,
	"./icon_list_request.svg": 397,
	"./icon_listar_carrinho.svg": 860,
	"./icon_listar_catalogo.svg": 861,
	"./icon_mensagem_enviada.svg": 557,
	"./icon_mensagem_recebida.svg": 558,
	"./icon_messenger.svg": 1265,
	"./icon_midia_dinamica.svg": 760,
	"./icon_modulo.svg": 862,
	"./icon_modulo_hover.svg": 1266,
	"./icon_permissoes.svg": 1267,
	"./icon_plugin_ativo.svg": 754,
	"./icon_remover_item_carrinho.svg": 863,
	"./icon_script.svg": 864,
	"./icon_script_hover.svg": 1268,
	"./icon_search.svg": 1269,
	"./icon_search_dark.svg": 746,
	"./icon_service_email.svg": 865,
	"./icon_service_facebook.svg": 866,
	"./icon_service_on.svg": 867,
	"./icon_service_telegram.svg": 559,
	"./icon_service_webchat.svg": 560,
	"./icon_service_whats.svg": 868,
	"./icon_setores.svg": 743,
	"./icon_settings.svg": 741,
	"./icon_settings_bot.svg": 1270,
	"./icon_settings_bot_apagado.svg": 1271,
	"./icon_show_request-1.svg": 307,
	"./icon_star.svg": 720,
	"./icon_status.svg": 683,
	"./icon_subflow.svg": 869,
	"./icon_tag.svg": 442,
	"./icon_telegram.svg": 1272,
	"./icon_tool_atendimento.svg": 1273,
	"./icon_tool_criador.svg": 749,
	"./icon_tool_settings.svg": 750,
	"./icon_upload.svg": 540,
	"./icon_usuarios.svg": 398,
	"./icon_usuarios_dark.svg": 744,
	"./icon_voicebot.svg": 745,
	"./icon_webchat.svg": 1274,
	"./icon_whats.svg": 1275,
	"./icon_zoom_in.svg": 561,
	"./icon_zoom_out.svg": 562,
	"./icone newbot.svg": 1276,
	"./icone-geral.svg": 742,
	"./icone-menu-ia.svg": 764,
	"./icone_advertencia.svg": 427,
	"./icone_campo_rd.svg": 870,
	"./icone_criar_lead.svg": 871,
	"./icone_esconder.svg": 350,
	"./icone_exportar_template.svg": 772,
	"./icone_integracao.svg": 1277,
	"./icone_newbot.svg": 872,
	"./icone_view.svg": 351,
	"./instagram_icon.svg": 330,
	"./loading_logo.svg": 670,
	"./loading_logo_center.svg": 671,
	"./logo-boteria-beta.svg": 1278,
	"./logo-boteria.svg": 717,
	"./logo-boteria1.svg": 1279,
	"./logo-code7-boteria-beta.svg": 1280,
	"./logo-code7-boteria.svg": 394,
	"./logo-code7.svg": 873,
	"./logo-dialogflow.svg": 874,
	"./logo-luis.svg": 875,
	"./logo_no_background.svg": 1281,
	"./lupaReport.svg": 454,
	"./menu.svg": 514,
	"./messengerQnt.svg": 1282,
	"./messenger_icon.svg": 308,
	"./midia_dinamica.svg": 876,
	"./plugin_novidade.svg": 753,
	"./ponto-interrogacao-cinza.svg": 1283,
	"./ponto-interrogacao.svg": 719,
	"./relatorios-icon.svg": 877,
	"./relatorios.svg": 751,
	"./reordenar_cima.svg": 878,
	"./report-time.svg": 879,
	"./resolver.svg": 455,
	"./robot.svg": 880,
	"./select_laranja.svg": 563,
	"./sessions.svg": 881,
	"./seta_drop.svg": 882,
	"./social/icone_face.svg": 1284,
	"./social/icone_github.svg": 1285,
	"./social/icone_google.svg": 1286,
	"./soon.svg": 1287,
	"./telefone.svg": 1288,
	"./tempo.svg": 883,
	"./tempo_ativo.svg": 884,
	"./testar.svg": 564,
	"./url.svg": 1289,
	"./user_no_profile_photo.svg": 440,
	"./validacao_celular_dark.svg": 773,
	"./validacao_celular_white.svg": 1290,
	"./validacao_cnpj_dark.svg": 774,
	"./validacao_cpf_dark.svg": 775,
	"./validacao_data_dark.svg": 776,
	"./validacao_data_white.svg": 1291,
	"./validacao_email_dark.svg": 777,
	"./validacao_email_white.svg": 1292,
	"./validacao_expressao_dark.svg": 778,
	"./validacao_expressao_white.svg": 1293,
	"./validacao_localizacao.svg": 1294,
	"./validacao_localizacao_dark.svg": 779,
	"./validacao_numero_dark.svg": 780,
	"./validacao_numero_white.svg": 1295,
	"./validacao_qualquer_coisa.svg": 1296,
	"./validacao_qualquer_coisa_dark.svg": 781,
	"./validacao_qualquer_coisa_white.svg": 1297,
	"./validacao_url_dark.svg": 782,
	"./validacao_url_white.svg": 1298,
	"./variavel.svg": 1299,
	"./variavel_orange.svg": 538,
	"./voltar.svg": 885,
	"./volume_mute.svg": 1300,
	"./volume_mute_actived.svg": 1301,
	"./volume_up.svg": 1302,
	"./webchat_icon.svg": 309,
	"./whatsapp_icon.svg": 310,
	"./whatsappteste.svg": 565,
	"./wit.svg": 886,
	"./zoom_mais.svg": 566,
	"./zoom_menos.svg": 887,
	"./zoom_tudo.svg": 888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 547;